import { Flex } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import type { DashboardSection } from '../../../types';
import { Card } from '../primitives';

// Report-card treatment: soft shadow, hover lift, big value.
export const KpiTiles = ({ section }: { section: DashboardSection }) => (
  <Flex wrap="wrap" gap="12px">
    {(section.kpis ?? []).map((k) => (
      <Card
        key={k.label}
        flex="1 1 170px"
        minW="170px"
        boxShadow="0px 2px 4px rgba(0, 0, 0, 0.05)"
        _hover={{
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          transform: 'translateY(-2px)',
        }}
        transition="all 0.2s ease-in-out"
      >
        <Text variant="h4" style={{ display: 'block' }}>
          {k.label}
        </Text>
        <Text variant="h3" className="!text-primary-900">
          {k.value}
        </Text>
        {k.hint && (
          <Text
            variant="overhead"
            className="text-[10px] text-secondary-500"
            style={{ display: 'block' }}
          >
            {k.hint}
          </Text>
        )}
      </Card>
    ))}
  </Flex>
);
